<template>
  <b-navbar
    toggleable="lg"
    style="width: 100%"
    fixed="top"
    :style="headStyle"
    :class="{ colors: colors }"
  >
    <div class="container">
      <b-navbar-brand href="#" style="width: 300px">
        <img src="../assets/img/logo1.png" style="float: left" />
        <div
            v-if="this.$root.language == 1"
            style="
            width: 120px;
            margin-left: 25px;
            float: left;
            line-height: 43px;
            color: #ffffff;
            font-weight: bold;
          "
        >
          安仑化工
        </div>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <!-- <b-nav-item><router-link to="/">首页1</router-link></b-nav-item> -->
          <b-nav-item><router-link to="/">{{this.$root.language == 1?'首页':'Index'}}</router-link></b-nav-item>
          <b-nav-item><router-link to="/goin">{{this.$root.language == 1?'走进安仑':'Know us'}}</router-link></b-nav-item>
          <b-nav-item><router-link to="/news">{{this.$root.language == 1?'新闻资讯':'News'}}</router-link></b-nav-item>
          <b-nav-item><router-link to="/case">{{this.$root.language == 1?'产品中心':'Product'}}</router-link></b-nav-item>
          <b-nav-item><router-link to="/search">{{this.$root.language == 1?'技术研发':'Technology'}}</router-link></b-nav-item>
          <b-nav-item><router-link to="/customer">{{this.$root.language == 1?'客户服务中心':'Service'}}</router-link></b-nav-item>
        </b-navbar-nav>
      </b-collapse>
      <!--  xyf 新增 ↓  -->
      <el-select v-model="lang" @change="changeLang" placeholder="请选择" style="width: 100px;margin-left: 70px;flex: none;float: right;">
        <el-option
            v-for="item in langOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </el-option>
      </el-select>
      <!--  xyf 新增 ↑  -->
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      lang:1,
      langOptions: [{
        value: 1,
        label: '中文'
      }, {
        value: 2,
        label: 'English'
      }],
      headStyle: {
        background: "rgba(255,255,255,0.2)",
        color: "rgba(255,255,255,1)",
      },
      colors: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    changeLang(val){
      // console.log(val);
      // console.log(this.$root.language);
      this.$root.language = val;
      // console.log(this.$root.language);
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      window.console.log(this.headStyle.background);
      if (scrollTop) {
        this.headStyle.background = `rgba(255,255,255,${
          scrollTop / (scrollTop + 80)
        })`;
        this.headStyle.color = `rgba(0,0,0,${scrollTop / (scrollTop + 80)})`;
        this.headStyle.background = `rgba(0,0,0,${
          scrollTop / (scrollTop + 80)
        })`;
        this.colors = true;
      } else if (scrollTop == 0) {
        this.headStyle.background = "rgba(255,255,255,0.2)";
        this.headStyle.color = "#ffffff";
        this.headStyle.background = `rgba(255, 255, 255, 0.2)`;
        this.headStyle.color = `rgba(255,255,255, 0.2)`;
        this.colors = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss" scoped>
/** xyf 新增 ↓ */
::v-deep .el-input__inner{
  border: none;
  box-shadow: none;
  background-color:transparent;
  color: white;
}
::v-deep .el-select .el-input .el-select__caret{
  color: white;
}
/** xyf 新增 ↑ */

.navbar {
  height: 80px;
  background-color: rgba(0, 0, 0, 0.1);
}
.container {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  .nav-item {
    width: 130px;
    .router-link-exact-active {
      color: #ee7a18;
    }
  }
  .nav-link {
    a {
      color: #ffffff;
    }
  }
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
</style>